import React from "react";
import {useTranslation} from "react-i18next";
import {Stack, Typography} from "@mui/material";
import {DateTimeFormatter} from "../../../common/DateTimeFormatter";
import {DetailsTable} from "../../../common/details/DetailsTable";
import {DetailsGenericRow} from "../../../common/details/DetailsGenericRow";
import {DetailsTextRow} from "../../../common/details/DetailsTextRow";
import {PersonDto} from "../../../client/person/PersonApiClient";
import {PersonTranslKey} from "../PersonTranslKey";
import {RobSubscriptionStatusFormatter} from "../RobSubscriptionStatusFormatter";

export interface PersonBasicDetailPanelProps {
    person: PersonDto;
}

export function PersonInfoPanel(props: Readonly<PersonBasicDetailPanelProps>) {
    const {person} = props;

    const { t } = useTranslation();

    return (
        <Stack spacing={2} padding={1}>
            <DetailsTable>
                <tbody>
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_FIRSTNAME)}
                    value={person.firstName}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_LASTNAME)}
                    value={person.lastName}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_EMAIL)}
                    value={person.email}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_PHONE)}
                    value={person.phone}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_DATA_ORIGIN)}
                    value={person.dataOrigin}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_ISZR_UPDATED_AT)}
                    value={DateTimeFormatter.formatDateTime(person.robUpdatedAt)}
                />
                <DetailsGenericRow label={t(PersonTranslKey.PERSON_AGENDA_SUBSCRIPTION_STATUSES)}>
                    <Stack spacing={0.5}>
                        {Object.entries(person.agendaSubscriptionStatus ?? {})
                                .sort(([leftCode], [rightCode]) => leftCode.localeCompare(rightCode))
                                .map(([agendaCode, status]) => (
                                        <Typography key={agendaCode} variant={"body2"}>
                                            <b>{`${agendaCode}: ${RobSubscriptionStatusFormatter.formatSubscriptionStatus(status, t)}`}</b>
                                        </Typography>
                                ))}
                    </Stack>
                </DetailsGenericRow>
                </tbody>
            </DetailsTable>
        </Stack>
    );
}
